export const getPagination = ({ pagination }) => pagination;
export const entidade_empty = () => ({
  nome: "",
  conselho_id: null,
});
